import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-up\">\n<path d=\"M12.0014 8.25006C11.8114 8.25006 11.6214 8.32006 11.4714 8.47006L5.47141 14.4701C5.18141 14.7601 5.18141 15.2401 5.47141 15.5301C5.76141 15.8201 6.24141 15.8201 6.53141 15.5301L12.0014 10.0601L17.4714 15.5301C17.7614 15.8201 18.2414 15.8201 18.5314 15.5301C18.8214 15.2401 18.8214 14.7601 18.5314 14.4701L12.5314 8.47006C12.3814 8.32006 12.1914 8.25006 12.0014 8.25006Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol